export class StringHelper {
    public static HtmlDecode(content: string): string {
        let textArea = document.createElement('textarea');
        textArea.innerHTML = content;
        return textArea.value;
    }
    
    public static RemoveCharacter(input: string, character: string): string {
        if (input === undefined || input === "")
            return "";
        
        return input.replaceAll(character, '');
    }
}
